"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.PureErrors = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _redux = require("redux");

var _reactRedux = require("react-redux");

var CommentsActions = _interopRequireWildcard(require("../../actions/comments"));

var _constants = require("../../constants");

var _Error = _interopRequireDefault(require("./Error"));

var _Errors = _interopRequireDefault(require("./Errors.scss"));

var _reducers = require("../../reducers");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var Errors = function Errors(_ref) {
  var commentClearError = _ref.commentClearError,
      errors = _ref.errors;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _Errors.default.component
  }, Object.keys(errors).map(function (errorLocation) {
    return /*#__PURE__*/_react.default.createElement(_Error.default, {
      onClose: commentClearError,
      errorLocation: errorLocation,
      errorType: errors[errorLocation],
      key: errorLocation
    });
  }));
};

exports.PureErrors = Errors;

var mapStateToProps = function mapStateToProps(state) {
  return {
    errors: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.errors"))
  };
};

exports.mapStateToProps = mapStateToProps;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    commentClearError: CommentsActions.commentClearError
  }, dispatch);
};

exports.mapDispatchToProps = mapDispatchToProps;
Errors.defaultProps = {
  errors: {}
};
Errors.propTypes = {
  errors: _propTypes.default.object,
  commentClearError: _propTypes.default.func.isRequired
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, undefined, {
  context: _reducers.reduxContext
})(Errors);

exports.default = _default;